function getCSRFToken() {
  return document.cookie.split('; ')
      .find(row => row.startsWith('csrf_access_token='))
      ?.split('=')[1];
}


export const returnIp = async () => {

if (window.location.origin === "http://localhost:3000" || window.location.origin === "http://localhost:3001" || window.location.origin === "http://192.168.0.118:3000"|| window.location.origin === "http://192.168.0.187:3000") {    // return "http://192.168.0.146:5002"
    // return "http://192.168.0.1:5002"
    return "http://localhost:5002"
  }
  return window.location.origin
}
export const ip = await returnIp()

export const fetchAPI = async (query) => {
  const url = `${ip}/${query}`;
  try {
    const response = await fetch(url);
    const json = await response.json();
    return json.data;
  } catch (error) {
    console.error(error.message);
  }
}

export const getAPI = async (query) => {
  const url = `${ip}/${query}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",

      },
    });
    const json = await response.json();
    return json;
  } catch (error) {
    console.error(error.message);
  }
}

export const postAPI = async (query, body) => {
  const url = `${ip}/${query}`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "csrf":getCSRFToken()
      },
      body: JSON.stringify(body)
    });
    var json = await response.json();
  
    return json;
  } catch (error) {
    return {"status":"error"}

    
  }
}
export const postAPImedia = async (query, body) => {
  const url = `${ip}/${query}`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers:{
        csrf:getCSRFToken()
      },
      body: body
    });
    var json = await response.json();
    return json;
  } catch (error) {
    console.error(error.message);
  }
}

export const updateAPI = async (query, body) => {
  const url = `${ip}/${query}`;
  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "csrf":getCSRFToken()
      },
      body: JSON.stringify(body)
    });
    var json = await response.json();
    return json;
  } catch (error) {
    console.error(error.message);
  }
}
export const deleteAPI = async (query, body) => {
  const url = `${ip}/${query}`;
  try {
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "csrf":getCSRFToken()
      },
      body: JSON.stringify(body)
    });
    var json = await response.json();
    return json;
  } catch (error) {
    console.error(error.message);
  }
}